import * as XLSX from "xlsx";
import { ACTIONS } from "../../context/ExcelFileUploadProvider";

export const readFile = (file, callback) => {
  const reader = new FileReader();
  // on_file_select event
  reader.onload = (event) => {
    callback({
      type: ACTIONS.SET_EXCEL_WORKBOOK,
      payload: { value: getWorkBook(event.target.result) },
    });
  };
  reader.readAsBinaryString(file);
};

export const getWorkBook = (excel) => {
  const workBook = XLSX.read(excel, { type: "binary" });
  if (!workBook) return;
  return workBook;
};

export const convertWorkSheetToJson = (workSheet) => {
  const json = XLSX.utils.sheet_to_json(workSheet, {
    header: 1,
    defval: "",
  });

  return json;
};

export const convertJsonToExcel = (json, fileName, sheetName) => {
  if (!json || json?.length === 0) {
    return;
  }
  if (!fileName || fileName?.length === 0) {
    return;
  }
  if (!sheetName || sheetName?.length === 0) {
    return;
  }
  const ws = XLSX.utils.json_to_sheet(json);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);

  XLSX.writeFile(wb, fileName + ".xlsx");
}
